// extracted by mini-css-extract-plugin
module.exports =  {"middle-navigation-btn":"_2787e5dfdf--middle-navigation-btn--OfGKw","large-navigation-btn":"_2787e5dfdf--large-navigation-btn--Lv2yM"};